import React from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import SeasonsSettingsPage from "../Seasons";
import PricesSettingsPage from "../Prices";
import { useHistory, useLocation } from "react-router-dom";
import AgeGroupSettingsPage from "../AgeGroups";

const PriceListSettingsPage = () => {
  const location = useLocation();
  const history = useHistory();

  const pathParts = location.pathname.split("/");
  const activeTab = pathParts[pathParts.length - 1] || "prices";

  const handleTabSelect = (key) => {
    history.push(`${key}`);
  };
  return (
    <>
      <Row>
        <Col>
          <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
            <Tab title="Preise" eventKey={"prices"}>
              {activeTab === "prices" && <PricesSettingsPage />}
            </Tab>
            <Tab title="Saisonen" eventKey={"seasons"}>
              {activeTab === "seasons" && <SeasonsSettingsPage />}
            </Tab>
            <Tab title="Altersgruppen" eventKey={"age-groups"}>
              {activeTab === "age-groups" && <AgeGroupSettingsPage />}
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default PriceListSettingsPage;
